<div [ngClass]="colClass">
    <div class="surface-card p-3 border-round">
        <div class="text-color-secondary text-sm">{{ label }}<app-platform-health-help-icon [text]="helpText"></app-platform-health-help-icon></div>
        <div class="text-2xl font-bold"><ng-content></ng-content></div>
    </div>
</div>
